import request from '@/utils/request'

export function updateBaseCfg(data) {
  return request({
    url: 'api/v1/base/updateBaseCfg',
    method: 'post',
    data: data
  })
}

export function getBaseCfgList(data) {
  return request({
    url: 'api/v1/base/getBaseCfg',
    method: 'get',
    params: data
  })
}

export function delBaseCfg(data) {
  return request({
    url: 'api/v1/base/delBaseCfg',
    method: 'delete',
    data: data
  })
}

